import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    AppLayout, Box, SpaceBetween, Header, 
    Container, Link,
    KeyValuePairs,
    CopyToClipboard,
    ExpandableSection
} from '@amzn/awsui-components-react';
import './history.scss'
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import moment from 'moment';
import { configureFlexicoAppSync, configureGenericAppSync } from 'src/context/AuthContextUtility'
import { getFlexicoTransaction } from 'src/utilities/FlexicoAPIs';
import EmbedResults from 'src/generic-components/EmbedResults/EmbedResults';
import { CodeView } from '@amzn/awsui-code-view';
import Feedback from 'src/generic-components/UserFeedback/Feedback';
import EmbedFlexicoParams from 'src/generic-components/EmbedResults/EmbedFlexicoParams';
import FlexicoTransactionFileListViewer from './FlexicoTransactionFileListViewer';


const FlexicoFileDetails = (props) => {

    const userAuthenticationDetails = useAuth();
    const gridRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch()
    const [error, setError] = useState(false);
    const [fileInfo, setFileInfo] = useState({});
    const [appId, setAppId] = useState(null);
    const [flexId, setFlexId] = useState(null);

    let { file_id } = useParams();
    const userId = useSelector((globalState) => globalState.auth.userId);

    useEffect(() => {
        configureFlexicoAppSync()
        fetchFileInfo(file_id)
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);

    const fetchFileInfo = (file_id) => {
        configureFlexicoAppSync()
        getFlexicoTransaction(file_id, function onSuccess(result) {
            setFileInfo(result.data.getFlexicoTransaction)

            setAppId(result?.data?.getFlexicoTransaction?.appId)
            setFlexId(result?.data?.getFlexicoTransaction?.flexId)
            configureGenericAppSync()
        }, function onFailure(response) {
            setError(true)
            configureGenericAppSync()
        })
    }

    const approvalStatusButton = (props) => {

        const getBadge = (status, id) => {
            const badgeClassMap = {
                pending: 'orange_badge',
                completed: 'green_badge',
                rejected: 'red_badge',
                cancelled: 'grey_badge',
            };

            if (status === 'NO APPROVAL') return null;

            const badgeClass = badgeClassMap[status] || 'blue_badge';
            const badge = <span className={badgeClass}>{status}</span>;

            if (id) {
                return (
                    <Link external href={`/ApprovalsHome/Workflow/${id}`}>
                        {badge}
                    </Link>
                );
            }

            return null;
        };

        const items = [
            props?.approvalStatus && props?.approvalId ? getBadge(props.approvalStatus, props.approvalId) : null,
            props?.rippleApprovalStatus && props?.rippleApprovalId ? getBadge(props.rippleApprovalStatus, props.rippleApprovalId) : null,
            props?.reviewStatus && props?.reviewId ? getBadge(props.reviewStatus, props.reviewId) : null,
        ];


        const filtered = items.filter(Boolean);

        return (<ul>
            <SpaceBetween direction="vertical" size="xs">

                {filtered.map((item, index) => (
                    <li><span key={index}>{item}</span></li>
                ))}

            </SpaceBetween> </ul>
        );

    }

    const fileDetails = (
        <SpaceBetween direction='vertical' size='s'>
            <Container
                header={
                    <Header
                        variant="h2"
                        description="Transaction details"
                    >
                        <SpaceBetween direction='horizontal' size='m'>
                            <Box variant="h2">Flexico trigger information </Box>
                            {appId?<Link href={`/App/${appId}`} external> App </Link>:'' }
                            {appId && flexId?<Link href={`/App/${appId}/flexico/${flexId}`} external> FlexiCo template </Link>:'' }                        </SpaceBetween>
                    </Header>
                }
            >
                <SpaceBetween direction='vertical' size='s'>
                <SpaceBetween direction='vertical'>
                    <KeyValuePairs
                        columns={4}
                        items={[
                            {
                                label: "File ID",
                                value: (
                                    <CopyToClipboard
                                        copyButtonAriaLabel="Copy File id"
                                        copyErrorText="Failed to copy"
                                        copySuccessText="File id copied"
                                        textToCopy={fileInfo.fileId|| '-'}
                                        variant="inline"
                                    />
                                )
                            },
                            {
                                label: "Status",
                                value: fileInfo.status|| '-'
                            },
                            {
                                label: "Uploaded by",
                                value: (
                                    <Box float="left">
                                        <img
                                            alt=""
                                            className="rounded-circle"
                                            src={
                                                "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=" +
                                                fileInfo.uploadedBy
                                            }
                                            width={20}
                                            height={20}
                                        />
                                        &nbsp;
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={"https://phonetool.amazon.com/users/" + fileInfo.uploadedBy}
                                        >
                                            {fileInfo.uploadedBy}
                                        </a>
                                    </Box>
                                )
                            },
                            {
                                label: "Uploaded at",
                                value: <Box>{moment(new Date(Number(fileInfo.uploadedTimestamp))).format()|| '-'}</Box>
                            },
                            {
                                label: "Last updated time",
                                value: <Box>{moment(new Date(Number(fileInfo.lastUpdatedTimestamp))).format()|| '-'}</Box>
                            }
                            ,
                            {
                                label: "Job trigger time",
                                value: <Box>{fileInfo.jobStartTime || '-'}</Box>
                            }
                            ,
                            {
                                label: "Approval",
                                value: approvalStatusButton(fileInfo)
                            }
                        ]}
                    />

                </SpaceBetween>
                
                <EmbedFlexicoParams fileId={fileInfo.fileId} transactionInfo={fileInfo}></EmbedFlexicoParams>
                {
                    fileInfo?.filePath && <FlexicoTransactionFileListViewer transactionDetails={fileInfo}></FlexicoTransactionFileListViewer>
                }
                
                </SpaceBetween>
            </Container>
            {
                fileInfo?.outputResultsS3 || fileInfo?.outputResults  ? <Container header={
                    <Header
                    variant="h2"
                    description="Output results generated by the contico job"
                >
                    Output
                </Header>
                }>
                    {
                        fileInfo ? <EmbedResults s3Bucket={fileInfo.bucketName} s3Reports={fileInfo.outputResultsS3} outputResults={fileInfo.outputResults} showAllAsTab={true}></EmbedResults>
                            : ''
                    }
                </Container>:''
            }

            {
                fileInfo && fileInfo.appId ? <Feedback appId={fileInfo.appId} pageId={`file_details_${file_id}`} userId={userId} parentId={"null"} level={0} limit={1}></Feedback>
                    : ''
            }

        </SpaceBetween>
    )

    const content = (
        <Box textAlign="center">
            {
                error ?
                    <Box variant="h1" color="text-status-error">Invalid id</Box> :
                    <Box> {fileDetails}</Box>
            }
        </Box>
    )

    return (
        <AppLayout
            content={content}
            headerSelector="#TopBar"
            navigationHide={true}
            maxContentWidth={Number.MAX_VALUE}
            headerVariant="high-contrast"
        ></AppLayout>
    );
}



export default FlexicoFileDetails

